export const checkFirstString = (data: string): string => {
  if (!data) return "";
  let r = "";
  if (data.charAt(0) == "+" || data.charAt(0) === "1") {
    r = `tel:${data.trim()}`;
  } else if (validateEmail(data)) {
    r = `mailto:${sanitizeEmail(data)}`;
  } else {
    r = "https://maps.app.goo.gl/akaC1Ko9ULseycrK7";
  }
  return r;
};

export const sanitizeEmail = (email: string): string => {
  if (!email) return "";
  return email
    .trim()
    .toLowerCase()
    .replace(/[\[\]]/g, "")
    .replace(/\(at\)/g, "@")
    .replace(/\(dot\)/g, ".");
};

export const validateEmail = (email: string): string | null => {
  if (!email || typeof email !== "string") return null;

  const sanitizedEmail = email
    .trim()
    .toLowerCase()
    .replace(/\(at\)/g, "@")
    .replace(/\(dot\)/g, ".");

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(sanitizedEmail) ? sanitizedEmail : null;
};
